import { render } from "./ClientBancosCuentas.vue?vue&type=template&id=42ba861f"
import script from "./ClientBancosCuentas.vue?vue&type=script&lang=js"
export * from "./ClientBancosCuentas.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__